import axios from 'axios';
import { markIncomplete } from './id';
import { prefilledRenter } from '../helpers/prefilledRenter';

const CREATE_RENTER_STARTED = 'CREATE_RENTER_STARTED';
const CREATE_RENTER_SUCCESS = 'CREATE_RENTER_SUCCESS';
const CREATE_RENTER_FAILURE = 'CREATE_RENTER_FAILURE';

const CREATE_REFERENCE_STARTED = 'CREATE_REFERENCE_STARTED';
const CREATE_REFERENCE_FAILURE = 'CREATE_REFERENCE_FAILURE';
const CREATE_REFERENCE_SUCCESS = 'CREATE_REFERENCE_SUCCESS';

const UPDATE_REFERENCE_STARTED = 'UPDATE_REFERENCE_STARTED';
const UPDATE_REFERENCE_FAILURE = 'UPDATE_REFERENCE_FAILURE';


const UPDATE_RENTER = 'UPDATE_RENTER';
const UPDATE_RENTER_REFERENCE = 'UPDATE_RENTER_REFERENCE';

const PREFILL_RENTER_STARTED = 'PREFILL_RENTER_STARTED';
const PREFILL_RENTER_SUCCESS = 'PREFILL_RENTER_SUCCESS';
const PREFILL_RENTER_FAILURE = 'PREFILL_RENTER_FAILURE';

const SAVE_RENTER_FAILURE = 'SAVE_RENTER_FAILURE';

const POST_RENTER_IMAGE_SUCCESS = 'POST_RENTER_IMAGE_SUCCESS';
const POST_RENTER_IMAGE_FAILURE = 'POST_RENTER_IMAGE_FAILURE';
const POST_RENTER_IMAGE_STARTED = 'POST_IMAGE_STARTED';

const DELETE_RENTER_IMAGE_SUCCESS = 'DELETE_RENTER_IMAGE_SUCCESS';
const DELETE_RENTER_IMAGE_FAILURE = 'DELETE_RENTER_IMAGE_FAILURE';
const DELETE_RENTER_IMAGE_STARTED = 'DELETE_RENTER_IMAGE_STARTED';


const ON_RENTER_ADDRESS_CHANGE = 'ON_RENTER_ADDRESS_CHANGE';

const SAVE_RENTER_ADDRESS_STARTED = 'SAVE_RENTER_ADDRESS_STARTED';
const SAVE_RENTER_ADDRESS_FAILURE = 'SAVE_RENTER_ADDRESS_FAILURE';
const SAVE_RENTER_ADDRESS_SUCCESS = 'SAVE_RENTER_ADDRESS_SUCCESS';

export function saveReference(contractId, refId, refData, idx) {
  return (dispatch) => {
    axios.put(`/contracts/${contractId}/update-reference/`, {
      reference_id: refId,
      ...refData
    })
      .then(() => dispatch(updateRenterReference({
        name: Object.keys(refData)[0],
        value: refData[Object.keys(refData)[0]],
        idx,
      })))
      .catch((err) => dispatch(updateReferenceFailure(err.response.data.ui_message)))
  }
}

const updateReferenceFailure = (err) => ({ type: UPDATE_REFERENCE_FAILURE, payload: err })


export function createReference(contractId, renterId, refIdx, referenceData) {
  return (dispatch) => {
    axios.post(`/contracts/${contractId}/add-reference/`, {
      contract_id: contractId,
      renter_id: renterId,
      ...referenceData,
    })
      .then(({ data }) => dispatch(createReferenceSuccess(data.id, refIdx, referenceData)))
      .catch((err) => dispatch(createReferenceFailure(err.response.data.ui_message)))
  }
}

const createReferenceSuccess = (refId, refIdx, referenceData) => ({
  type: CREATE_REFERENCE_SUCCESS,
  payload: {
    refId,
    refIdx,
    ...referenceData,
}})
const createReferenceFailure = (err) => ({ type: CREATE_REFERENCE_FAILURE, payload: err })

export function createRenter(contractId, email) {
  return (dispatch) => {
    dispatch(createRenterStarted())

    axios.put(`/contracts/${contractId}/add-renter/`, { email })
      .then(({ data }) => dispatch(createRenterSuccess(data.renter_id, email)))
      .then(() => dispatch(markIncomplete(contractId)))
      .catch((err) => dispatch(createRenterFailure(err.response.data.ui_message)))
  }
}

const createRenterSuccess = (id, email) => ({
  type: CREATE_RENTER_SUCCESS,
  payload: { id, email }
})

const createRenterFailure = (err) => ({
  type: CREATE_RENTER_FAILURE,
  payload: err,
})

const createRenterStarted = () => ({ type: CREATE_RENTER_STARTED })

export function saveRenter(renterId, renterData) {
  return (dispatch) => {
    axios.put(`/contracts/${renterId}/`, renterData)
      .then(() => dispatch(updateRenter(renterData)))
      .catch((err) => dispatch(saveRenterFailure((err.response.data.ui_message))))
  }
}

function saveRenterFailure(error) {
  return { type: SAVE_RENTER_FAILURE, payload: error }
}

export function prefillRenter(contractId, renterId) {
  return (dispatch) => {
    dispatch(prefillRenterStarted())

    const postData = {
      ...prefilledRenter,
      renter_id: renterId,
    };

    axios.post(`/contracts/${contractId}/prefill-renter/`, postData)
      .then(({ data }) => dispatch(prefillRenterSuccess({
        ...prefilledRenter,
        references: [...data.references],
      })))
      .catch((err) => dispatch(prefillRenterFailure(err.response.data.ui_message)))
  }
}

const prefillRenterStarted = () => ({ type: PREFILL_RENTER_STARTED });

function prefillRenterSuccess(prefilledRenter) {
  return {
    type: PREFILL_RENTER_SUCCESS,
    payload: prefilledRenter,
  }
}

function prefillRenterFailure(err) {
  return {
    type: PREFILL_RENTER_FAILURE,
    payload: err,
  }
}

export function updateRenter(renter) {
  return { type: UPDATE_RENTER, payload: renter }
}

export function updateRenterReference(reference) {
  return { type: UPDATE_RENTER_REFERENCE, payload: reference }
}

export const postRenterImage = (postData) => {
  return (dispatch) => {
    dispatch(postRenterImageStarted());

    axios.post(postData.url, postData.imageData)
      .then(({ data }) => {
        dispatch(postRenterImageSuccess({
          image: data[postData.responseKey],
          key: postData.stateKey,
        }))
      })
      .catch((err) => {
        dispatch(postRenterImageFailure(err.response.data.ui_message))
      })
  }
}

const postRenterImageStarted = () => ({ type: POST_RENTER_IMAGE_STARTED })

const postRenterImageFailure = (error) => ({
  type: POST_RENTER_IMAGE_FAILURE,
  payload: error,
})

const postRenterImageSuccess = (image) => ({
  type: POST_RENTER_IMAGE_SUCCESS,
  payload: image,
});

export const deleteRenterImage = (postData) => {
  return (dispatch) => {
    dispatch(deleteRenterImageStarted());

    axios.delete(postData.url)
      .then(({ data }) => {
        dispatch(deleteRenterImageSuccess(postData.stateKey))
      })
      .catch((err) => {
        dispatch(deleteRenterImageFailure(err.response.data.ui_message))
      })
  }
}

const deleteRenterImageStarted = () => ({ type: DELETE_RENTER_IMAGE_STARTED })

const deleteRenterImageFailure = (error) => ({
  type: DELETE_RENTER_IMAGE_FAILURE,
  payload: error,
})

const deleteRenterImageSuccess = (imageKeyName) => ({
  type: DELETE_RENTER_IMAGE_SUCCESS,
  payload: imageKeyName,
});

function renterReducer(state, action) {
  switch (action.type) {
    case CREATE_REFERENCE_STARTED:
      return {
        ...state,
        loading: true,
      }
    case CREATE_REFERENCE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case CREATE_REFERENCE_SUCCESS:
      const refs = [...state.renter.references];
      const createdRef = refs[action.payload.refIdx];
      createdRef.id = action.payload.refId;

      return {
        ...state,
        loading: false,
        renter: {
          ...state.renter,
          references: refs,
        }
      }
    case CREATE_RENTER_STARTED:
      return {
        ...state,
        loading: true,
      }
    case CREATE_RENTER_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case CREATE_RENTER_SUCCESS:
      return {
        ...state,
        loading: false,
        renter: {
          ...state.renter,
          email: action.payload.email,
          id: action.payload.id,
          references: [
            { id: null, email: '', first_name: '', last_name: '', phone: '', relationship: ''  },
            { id: null, email: '', first_name: '', last_name: '', phone: '', relationship: ''  },
          ],
        }
      }
    case DELETE_RENTER_IMAGE_STARTED:
      return {
        ...state,
        loading: true,
      }
    case DELETE_RENTER_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case DELETE_RENTER_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload]: null,
      }
    case POST_RENTER_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload.key]: action.payload.image,
      }
    case POST_RENTER_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case POST_RENTER_IMAGE_STARTED:
      return {
        ...state,
        loading: true,
      }
    case PREFILL_RENTER_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case PREFILL_RENTER_STARTED:
      return {
        ...state,
        loading: true,
      }
    case PREFILL_RENTER_SUCCESS:
      return {
        ...state,
        loading: false,
        renter: {
          ...state.renter,
          ...action.payload,
        }
      }
    case SAVE_RENTER_FAILURE:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_RENTER:
      return {
        ...state,
        renter: {
          ...state.renter,
          ...action.payload,
        },
      }
    case UPDATE_REFERENCE_FAILURE:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_RENTER_REFERENCE:
      const newRenterRefs = [...state.renter.references];
      const newRef = newRenterRefs[action.payload.idx];
      newRef[action.payload.name] = action.payload.value;

      return {
        ...state,
        renter: {
          ...state.renter,
          references: newRenterRefs,
        },
      }
    default:
      return state
  }

  return state;
}

export default renterReducer;
